import React, { history, useEffect, useState, useMemo, useRef } from "react";
import Hiring from "../Jobs/Hiring";
import Recent_Jobs from "../Jobs/Recent_Jobs";
import Pagination3 from "../../utility/Pagination/Pagination";
import Services from "../../services/services";
import $, { parseJSON } from 'jquery';
import ReactPlayer from 'react-player';
import Select, { components } from 'react-select';

const VideoLibrary = () => {
   const companyIdChkLogin = sessionStorage.getItem("logCompanyId") || localStorage.getItem("logCompanyId");
   const studentIdChkLogin = sessionStorage.getItem("logStudentId") || localStorage.getItem("logStudentId");
   const jobSeekerIdChkLogin = sessionStorage.getItem("logProfileId") || localStorage.getItem("logProfileId");
   const userIdChkLogin = sessionStorage.getItem("logUserId") || localStorage.getItem("logUserId");
   const chKRoleAr = sessionStorage.getItem("roleAr") || localStorage.getItem("roleAr");

   const ITEMS_PER_PAGE = 10; // Per page show the data pagination
   const [totalItems, setTotalItems] = useState(0);
   const [totalpages, settotalPages] = useState();
   const [currentPage, setCurrentPage] = useState(1);
   const [videoList, setVideoList] = useState([]);
   const [playingVideo, setPlayingVideo] = useState({ companyIndex: null, videoIndex: null });
   const [showPagination, setShowPagination] = useState(false);
   const companyInputRef = useRef(null);

   const [mulcategories, setMulCategories] = useState([]);       // Industry dropdown options
   const [mullocationCounty, setMulLocationCounty] = useState([]); // County dropdown options
   // Replace with correct variable names from your code if different
   const industryOptions = mulcategories || [];
   const countyOptions = mullocationCounty || [];


   const [menuOpen, setMenuOpen] = useState(false);
  const selectRef = useRef(null);

   const [menu2Open, setMenu2Open] = useState(false);
   const select2Ref = useRef(null);
    useEffect(() => {
    const handleClickOutside = (event) => {
      if (selectRef.current && !selectRef.current.contains(event.target)) {
        setMenuOpen(false);
      }

      if (select2Ref.current && !select2Ref.current.contains(event.target)) {
        setMenu2Open(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
   useEffect(() => {
      // Replace with your real fetching functions
      //Services.getIndustryData().then((res) => setMulCategories(res.data.content));



      Services.getIndustryData().then((res) => {
         //setCategory(res.data.content);
         var serviceresponse = res.data.content;
         var dummArray = [];
         for (var i = 0; i < res.data.content.length; i++) {
            dummArray.push({ "label": res.data.content[i].name, "value": res.data.content[i].catId })
         }
         setMulCategories(dummArray);
         //setMulCategory_d(dummArray);
         var storeval = JSON.stringify(serviceresponse);
         // sessionStorage.setItem('master_industry', storeval);
      });

      //Services.getLocationCounty().then((res) => setMulLocationCounty(res.data.content));




      Services.getLocationCounty().then((res) => {
         //setLocationCounty(res.data.content);
         var serviceresponse = res.data.content;
         // alert(res.data.content.length)
         var dummArray = [];
         for (var i = 0; i < res.data.content.length; i++) {
            dummArray.push({ "label": res.data.content[i].name, "value": res.data.content[i].jobLocationCountyId })
         }
         setMulLocationCounty(dummArray);
         var storelocval = JSON.stringify(serviceresponse);
         // sessionStorage.setItem('master_location', storelocval);
      });


   }, []);


   //////////////
   const [companyName, setCompanyName] = useState('');
   const [tempCompanyName, setTempCompanyName] = useState("");
   const [selectedIndustry, setSelectedIndustry] = useState([]); // [] instead of ''
   const [selectedCounty, setSelectedCounty] = useState([]);     // [] instead of ''
   const [showFilterModal, setShowFilterModal] = useState(false);

   const handleInputChange = (e) => {
      //setTempCompanyName(e.target.value);
      setCompanyName(e.target.value);
   };

   // Update companyName only when input loses focus
   const handleInputBlur = () => {
      setCompanyName(tempCompanyName);
      // Optionally trigger filtering or API call here using updated companyName
   };

   const CustomSelectOption2 = (props) => {
      return (
         <components.Option {...props}>
            <input
               type="checkbox"
               checked={props.isSelected}
               onChange={() => null}
               style={{ marginRight: 8 }}
            />
            <label>{props.label}</label>
         </components.Option>
      );
   };

   const CustomSelectOption = (props) => {
      return (
         <components.Option {...props}>
            <div style={{ display: "flex", alignItems: "center", flexWrap: "nowrap" }}>
               <input
                  type="checkbox"
                  checked={props.isSelected}
                  onChange={() => null}
                  style={{ marginRight: 8, flexShrink: 0 }}
               />
               <span
                  title={props.label} // Tooltip with full label on hover
                  style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}
               >
                  {props.label}
               </span>
            </div>
         </components.Option>
      );
   };


   const MAX_VISIBLE = 1;      // How many chips to show fully
   const MAX_LABEL_LENGTH = 15; // Max characters per chip label before truncation


   const CustomValueContainer = ({ children, ...props }) => {
      const selected = props.getValue();
      const visible = selected.slice(0, MAX_VISIBLE);
      const hiddenCount = selected.length - MAX_VISIBLE;

      return (
         <components.ValueContainer {...props}>
            <div
               style={{
                  // display: "flex",          // Use flexbox
                  // alignItems: "center",     // Align vertically center
                  // gap: "4px",               // Space between items
                  // flexWrap: "nowrap",       // Prevent wrapping to next line
                  // overflow: "hidden",       // Avoid overflow issues
                  // maxWidth: "100%",         // Constrain width if needed
               }}
               className='customSelectVideo'
            >
               {visible.map(option => (
                  <span
                     key={option.value}
                     style={{
                        display: "inline-block",
                        background: "#eee",
                        borderRadius: 4,
                        padding: "2px 8px",
                        fontSize: 13,
                        maxWidth: 100,
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        verticalAlign: "middle",
                     }}
                     title={option.label} // show full text on hover
                  >
                     {option.label.length > MAX_LABEL_LENGTH
                        ? option.label.slice(0, MAX_LABEL_LENGTH) + "..."
                        : option.label}
                  </span>
               ))}

               {hiddenCount > 0 && (
                  <span
                     style={{
                        display: "inline-block",
                        background: "#d7eaff",
                        borderRadius: 4,
                        padding: "2px 8px",
                        fontSize: 13,
                        color: "#2266aa",
                        fontWeight: 600,
                        verticalAlign: "middle", marginLeft: 2,
                     }}
                     title={`${hiddenCount} more`}
                  >
                     +{hiddenCount}
                  </span>
               )}

               {selected.length === 0 && (
                  <span
                     className="videoLibrarySelectPlaceHolder"
                     style={{

                     }}
                  >{props.selectProps.placeholder}</span>
               )}

            </div>
            {children[1]} {/* render input/search box */}
         </components.ValueContainer>
      );
   };

   // Optional: you can also customize MultiValue for chip display inside dropdown input, if needed
   const CustomMultiValue = (props) => {
      const label = props.data.label;
      const truncatedLabel =
         label.length > MAX_LABEL_LENGTH ? label.slice(0, MAX_LABEL_LENGTH) + "..." : label;
      return (
         <components.MultiValue {...props}>
            <div title={label}>{truncatedLabel}</div>
         </components.MultiValue>
      );
   };


   const handleFilterSubmit = (e) => {
      e.preventDefault();
      // Build filter object from state
      const filters = {
         companyName,
         industry: selectedIndustry,
         county: selectedCounty,
      };
      // Pass filters to your API call
      getVideoListWithFilters(ITEMS_PER_PAGE, 1, filters); // You'll need to implement this function based on your API
   };

   const handleReset = (e) => {
      e.preventDefault();
      setCompanyName('');
      setSelectedIndustry([]);
      setSelectedCounty([]);

       const filters = {
         companyName,
         industry: selectedIndustry,
         county: selectedCounty,
      };

      //getVideoList(ITEMS_PER_PAGE, 1); // Reset list to unfiltered state
      //getVideoListWithFilters(ITEMS_PER_PAGE, 1, filters);
   };

   // const propsNeededForForm = {
   //    companyName,
   //    setCompanyName,
   //    selectedIndustry,
   //    setSelectedIndustry,
   //    selectedCounty,
   //    setSelectedCounty,
   //    handleFilterSubmit,
   //    handleReset,
   //    industryOptions,
   //    countyOptions,
   //    Option,
   //    CustomOption,
   //    CustomValueContainer,
   //    CustomMultiValue
   // };



   const FilterForm = ({ companyName, setCompanyName, selectedIndustry = [], setSelectedIndustry, selectedCounty = [], setSelectedCounty, handleFilterSubmit, handleReset, industryOptions = [], countyOptions = [], CustomOption, CustomValueContainer, CustomMultiValue }) => (
      <form onSubmit={handleFilterSubmit} className="vl-horizental-bar align-items-center">
         {/* Company Name */}
         <div className="d-grid">
            <b><label htmlFor="companyName" className="form-label">COMPANY NAME</label></b>
            <input
               className="vl-input form-control"
               type="text"
               //value={companyName}
               value={tempCompanyName}
               placeholder="Search by Company"
               //onChange={e => setCompanyName(e.target.value)}
               onChange={handleInputChange}
               onBlur={handleInputBlur}
            />
         </div>

         {/* Industry Select */}
         <div className="d-grid">
            <b><label htmlFor="industry" className="form-label">INDUSTRY</label></b>
            <Select
               options={industryOptions}
               isMulti
               closeMenuOnSelect={true}
               hideSelectedOptions={false}
               components={{ Option: CustomSelectOption, ValueContainer: CustomValueContainer, MultiValue: CustomMultiValue }}
               onChange={(selectedOptions) => setSelectedIndustry(selectedOptions ? selectedOptions.map(o => o.value) : [])}
               value={industryOptions.filter(i => selectedIndustry.includes(i.value))}
               placeholder="Select Industries"
            />
         </div>

         {/* County Select */}
         <div className="d-grid">
            <b><label htmlFor="county" className="form-label">LOCATION</label></b>
            <Select
               options={countyOptions}
               isMulti
               closeMenuOnSelect={true}
               hideSelectedOptions={false}
               components={{ Option, ValueContainer: CustomValueContainer }}
               onChange={(selectedOptions) => setSelectedCounty(selectedOptions ? selectedOptions.map(o => o.value) : [])}
               value={countyOptions.filter(c => selectedCounty.includes(c.value))}
               placeholder="Select Location"
            />
         </div>

         {/* Buttons */}
         <div className="align-self-end position-relative filterButtonwrap hto-desktop">
            <a href="#" onClick={handleReset} className="resetall" >Reset All</a>
            <button className="filterButton" type="submit">FILTER</button>
         </div>
         <div className="align-self-end position-relative filterButtonwrap hto-mobile">
            <a href="#" onClick={handleReset} className="btn btn-secondary text-uppercase mx-2" >Reset</a>
            <button className="btn btn-primary text-uppercase" type="submit">FILTER</button>
         </div>
      </form>
   );



   const CustomOption = (props) => {
      return (
         <components.Option {...props}>
            <div style={{ display: "flex", alignItems: "center", flexWrap: "nowrap" }}>
               <input
                  type="checkbox"
                  checked={props.isSelected}
                  onChange={() => null}
                  style={{ marginRight: 8, flexShrink: 0 }}
               />
               <span
                  title={props.label} // Tooltip with full label on hover
                  style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}
               >
                  {props.label}
               </span>
            </div>
         </components.Option>
      );
   };











   const Option = (props) => {
      return (
         <components.Option {...props}>
            <input
               type="checkbox"
               checked={props.isSelected}
               onChange={() => null} // checkbox change is handled by react-select internally
               style={{ marginRight: 8 }}
            />
            <label>{props.label}</label>
         </components.Option>
      );
   };








   const getVideoListWithFilters = (ITEMS_PER_PAGE, pageNumber, filters) => {
      // Modify requestObject with filter parameters for companyName, industry, county
      const requestObject = {
         siteId: process.env.REACT_APP_SITE_ID,
         pageNumber: pageNumber,
         pageSize: ITEMS_PER_PAGE,
         companySearch: filters.companyName,
         industryIds: filters.industry,
         countyIds: filters.county,
      };
      // ...existing fetch logic
      setShowFilterModal(false);
      const requestOptions = {
         method: 'POST',
         headers: {
            'Content-Type': 'application/json',
            //'Authorization': "Bearer "+accessTokenIn
            //'Authorization': accessTokenIn
         },
         body: JSON.stringify(requestObject)
      };

      Services.getMultipleCompanyVideosPost(requestOptions).then((res) => {
         console.log("############36");
         console.log(JSON.stringify(res))
         if (res.content && res.content.length > 0) {
            console.log(JSON.stringify(res));
            $(".paginationContent").show();
            setTotalItems(res.totalElements);
            settotalPages(Math.ceil(res.totalElements / ITEMS_PER_PAGE));
            setCurrentPage(pageNumber);

            var contAr = res.content;
            //setProfileList(res.content);
            if (res.content) {
               setVideoList(res.content);
            }
            setShowPagination(true);


         } else {
            $(".paginationContent").hide();
            setVideoList([]);
            setShowPagination(false);
         }
         //navigate('/thankyou');

      });


   };





   ///////////////

   const getVideoList = (ITEMS_PER_PAGE, pageNumber) => {
      //alert("14");
      const requestObject = {
         "siteId": process.env.React_App_SITE_ID,
         "pageNumber": pageNumber,
         "pageSize": ITEMS_PER_PAGE,
         //  companySearch: filters.companyName,
         // industryIds: filters.industry,
         // countyIds: filters.county,
      }

      var accessTokenIn = sessionStorage.getItem("accToken") || localStorage.getItem("accToken");
      const requestOptions = {
         method: 'POST',
         headers: {
            'Content-Type': 'application/json',
            //'Authorization': "Bearer "+accessTokenIn
            //'Authorization': accessTokenIn
         },
         body: JSON.stringify(requestObject)
      };

      Services.getMultipleCompanyVideosPost(requestOptions).then((res) => {
         console.log("############36");
         console.log(JSON.stringify(res))
         if (res.content && res.content.length > 0) {
            console.log(JSON.stringify(res));
            $(".paginationContent").show();
            setTotalItems(res.totalElements);
            settotalPages(Math.ceil(res.totalElements / ITEMS_PER_PAGE));
            setCurrentPage(pageNumber);

            var contAr = res.content;
            //setProfileList(res.content);
            if (res.content) {
               setVideoList(res.content);
            }
            setShowPagination(true);


         } else {
            setShowPagination(false);
            $(".paginationContent").hide();
         }
         //navigate('/thankyou');

      });


   }

   const getVideoListOld = (ITEMS_PER_PAGE, pageNumber) => {
      //alert("14");
      const requestObject = {
         "siteId": process.env.React_App_SITE_ID,
         "pageNumber": pageNumber,
         "pageSize": ITEMS_PER_PAGE
      }

      var accessTokenIn = sessionStorage.getItem("accToken") || localStorage.getItem("accToken");
      const requestOptions = {
         method: 'POST',
         headers: {
            'Content-Type': 'application/json',
            //'Authorization': "Bearer "+accessTokenIn
            //'Authorization': accessTokenIn
         },
         body: JSON.stringify(requestObject)
      };

      Services.getVideosBySite(requestOptions).then((res) => {
         console.log("############36");
         console.log(JSON.stringify(res))
         if (res.content) {
            console.log(JSON.stringify(res));
            $(".paginationContent").show();
            setTotalItems(res.totalElements);
            settotalPages(Math.ceil(res.totalElements / ITEMS_PER_PAGE));
            setCurrentPage(pageNumber);

            var contAr = res.content;
            //setProfileList(res.content);
            if (res.content) {
               setVideoList(res.content);
            }


         }
         //navigate('/thankyou');

      });


   }

   function getId(url) {
      var regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
      var match = url.match(regExp);

      if (match && match[2].length == 11) {
         return match[2];
      } else {
         return 'error';
      }
   }

   function getEmbedVideo(myvidurl) {
      return myvidurl;
      var vidId = getId(myvidurl);
      if (vidId == 'error') {
         var embed_videourl = myvidurl;
      }
      else {

         //console.log(myvidurl+"---"+vidId);

         var embed_videourl = "https://www.youtube.com/embed/" + vidId;
      }
      //console.log(embed_videourl);
      return embed_videourl;
   }

   const handlePageChange3 = (offset, triggerevent) => {
       const filters = {
         companyName,
         industry: selectedIndustry,
         county: selectedCounty,
      };
      //getVideoList(ITEMS_PER_PAGE, offset);
      getVideoListWithFilters(ITEMS_PER_PAGE, offset, filters);
   };

   useEffect(() => {
      const jsonData = {
         "videoLibrary": {

         }
      };
      var jsondataformatted = JSON.stringify(jsonData);
      sessionStorage.setItem('pagejsonObject', jsondataformatted);

      //getTopCompanyHiringList();
      //filterContent(ITEMS_PER_PAGE,offset);
      //filterEvents(ITEMS_PER_PAGE,'1');
      const filters = {
         companyName,
         industry: selectedIndustry,
         county: selectedCounty,
      };
      getVideoListWithFilters(ITEMS_PER_PAGE, 1, filters);
      //getVideoList(ITEMS_PER_PAGE, '1');

   }, []);




   useEffect(() => {
      const handleCarouselChange = (e) => {
         const id = e.target.id; // e.g., "carouselExampleIndicators0"
         const companyIndex = parseInt(id.replace("carouselExampleIndicators", ""), 10);

         // Find the active slide index after transition
         const items = e.target.querySelectorAll('.carousel-item');
         let activeIndex = -1;
         items.forEach((item, i) => {
            if (item.classList.contains('active')) {
               activeIndex = i;
            }
         });

         if (activeIndex !== -1) {
            setPlayingVideo({ companyIndex, videoIndex: activeIndex });
         }
      };

      // Add listener to all carousels
      const carousels = document.querySelectorAll('.carousel');
      carousels.forEach((carousel) => {
         carousel.addEventListener('slid.bs.carousel', handleCarouselChange);
      });

      // Cleanup
      return () => {
         carousels.forEach((carousel) => {
            carousel.removeEventListener('slid.bs.carousel', handleCarouselChange);
         });
      };
   }, []);

   return (
      <>
         <main class="empr-directory-main">
            <div class="main-bgpatten"></div>
            {/* <!-- info typography --> */}
            <section class="headtitle-wrap">
               <div class="container">
                  <div class="row">
                     <div class="col-lg-12">
                        <nav style={{ "--bs-breadcrumb-divider": "'>';" }} aria-label="breadcrumb">
                           <ol class="breadcrumb">

                              {(() => {

                                 if (jobSeekerIdChkLogin != null && jobSeekerIdChkLogin != "null") {
                                    return (<><li class="breadcrumb-item headtitle"> <a href="/profileDashboard">Job Seeker Dashboard</a> </li> </>);
                                 }

                                 if (chKRoleAr == "schooladmin" || chKRoleAr == "schoolsuper") {
                                    return (<><li class="breadcrumb-item headtitle"> <a href="/schoolAdminDashboard">School Admin</a> </li> </>);
                                 }



                                 if (studentIdChkLogin != null && studentIdChkLogin != "null") {
                                    return (<><li class="breadcrumb-item headtitle"> <a href="/studentDashboard">Student Dashboard</a> </li> </>);
                                 }

                              })()}

                              <li class="breadcrumb-item headtitle "><a href="#">Video Library</a></li>
                           </ol>
                        </nav>
                     </div>
                  </div>
               </div>
            </section>
            {/* <!-- info typography --> */}
            <section class="info-typography py-5 ofx-hid-mob ">
               <div class="container">

                  <div class="row">
                     <div class="col-lg-8">
                        <div class="py-5 px-5 white-bg" style={{ paddingBottom: "20px !important" }}>
                           <p class="text_abovehead mt-1">Explore our video library for valuable insights into our local companies, their operations, and the exciting career opportunities they offer.</p>

                           <div className="filter-bar-container" style={{ marginBottom: 32 }}>
                              <div className="filter-bar-container" style={{ marginBottom: 32 }}>
                                 {/* <FilterForm {...propsNeededForForm} /> */}


                                 <form onSubmit={handleFilterSubmit} className="vl-horizental-bar align-items-center">
                                    {/* Company Name */}
                                    <div className="d-grid">
                                       <b><label htmlFor="companyName" className="form-label">COMPANY NAME</label></b>
                                       <input
                                          ref={companyInputRef}
                                          className="vl-input form-control"
                                          type="text"
                                          value={companyName}
                                          placeholder="Search by Company"
                                          onChange={handleInputChange}
                                       />
                                    </div>

                                    {/* Industry Select */}
                                    <div className="d-grid" ref={selectRef}>
                                       <b><label htmlFor="industry" className="form-label">INDUSTRY</label></b>
                                       {/* <Select
                                          options={industryOptions}
                                          isMulti
                                          closeMenuOnSelect={false}
                                          menuShouldCloseOnSelect={true}
                                          hideSelectedOptions={false}
                                          components={{ Option: CustomSelectOption, ValueContainer: CustomValueContainer, MultiValue: CustomMultiValue }}
                                          onChange={(selectedOptions) => setSelectedIndustry(selectedOptions ? selectedOptions.map(o => o.value) : [])}
                                          value={industryOptions.filter(i => selectedIndustry.includes(i.value))}
                                          placeholder="Select Industries"

                                          onMenuOpen={() => setMenuOpen(true)}
                                          onMenuClose={() => setMenuOpen(false)}
                                       /> */}

                                       <Select
                                          options={industryOptions}
                                          isMulti
                                          closeMenuOnSelect={false}      // keep open while selecting
                                          hideSelectedOptions={false}    // show already selected with checkmark
                                          menuIsOpen={menuOpen}          // controlled
                                          onMenuOpen={() => setMenuOpen(true)}
                                          onMenuClose={() => setMenuOpen(false)}
                                          components={{ Option: CustomSelectOption, ValueContainer: CustomValueContainer, MultiValue: CustomMultiValue }}
                                          onChange={(selectedOptions) =>
                                             setSelectedIndustry(
                                                selectedOptions ? selectedOptions.map((o) => o.value) : []
                                             )
                                          }
                                          value={industryOptions.filter((i) =>
                                             selectedIndustry.includes(i.value)
                                          )}
                                          placeholder="Select Industries"


                                          onInputChange={(value, { action }) => {
                                             if (action === "input-change") {
                                                setMenuOpen(true);               // open on typing
                                             }
                                          }}
                                          onFocus={() => setMenuOpen(true)}

                                       />
                                    </div>

                                    {/* County Select */}
                                    <div className="d-grid" ref={select2Ref}>
                                       <b><label htmlFor="county" className="form-label">LOCATION</label></b>
                                       <Select
                                          options={countyOptions}
                                          isMulti
                                          closeMenuOnSelect={false}
                                          hideSelectedOptions={false}
                                          components={{ Option: CustomSelectOption, ValueContainer: CustomValueContainer }}
                                          onChange={(selectedOptions) => setSelectedCounty(selectedOptions ? selectedOptions.map(o => o.value) : [])}
                                          value={countyOptions.filter(c => selectedCounty.includes(c.value))}
                                          placeholder="Select Location"

                                          menuIsOpen={menu2Open} 
                                          onMenuOpen={() => setMenu2Open(true)}
                                          onMenuClose={() => setMenu2Open(false)}
                                          onFocus={() => setMenu2Open(true)}
                                       />
                                    </div>

                                    {/* Buttons */}
                                    <div className="align-self-end position-relative filterButtonwrap hto-desktop">
                                       <a href="#" onClick={handleReset} className="resetall">Reset</a>
                                       <button className="filterButton" type="submit">FILTER</button>
                                    </div>
                                    <div className="align-self-end position-relative filterButtonwrap hto-mobile">
                                       <a href="#" onClick={handleReset} className="btn btn-secondary text-uppercase mx-2">Reset</a>
                                       <button className="btn btn-primary text-uppercase" type="submit">FILTER</button>
                                    </div>
                                 </form>


                              </div>
                           </div>


                           <button
                              className="btn btn-primary mobile-filter-button"
                              // style={{ display: "none" }} // initially hidden, shown by CSS on mobile
                              onClick={() => setShowFilterModal(true)}
                           >
                              Filter Preferences
                           </button>




                           <div class="row">



                              {
                                 videoList.map((data, index) => (


                                    <div class="video-section2 mb-4">
                                       <div class="video-item">


                                          <div id={"carouselExampleIndicators" + index} class="carousel slide vid-gal" data-bs-ride="false"
                                             data-bs-interval="false">
                                             <div class="carousel-inner" data-bs-target={"#carouselExampleIndicators" + index}>
                                                {
                                                   data.companyVideos.map((data3, index3) => (

                                                      <div class={index3 == 0 ? "carousel-item active" : "carousel-item "}>

                                                         {/* <iframe width="100%" height="100%" src={data.companyVideos[index3]} allowfullscreen="allowfullscreen" /> */}
                                                         <ReactPlayer
                                                            url={data.companyVideos[index3]}
                                                            class="vidlib-cont-all fb-video"
                                                            controls="true"
                                                            playing={
                                                               playingVideo.companyIndex === index && playingVideo.videoIndex === index3
                                                            }
                                                            onPlay={() => setPlayingVideo({ companyIndex: index, videoIndex: index3 })}
                                                            config={
                                                               {
                                                                  facebook: {
                                                                     attributes: {
                                                                        'data-width': 'auto',
                                                                        'data-height': 'auto'
                                                                     }
                                                                  }
                                                               }
                                                            } />
                                                      </div>


                                                   ))}
                                             </div>




                                             <button
                                                className={data.companyVideos.length > 1 ? "carousel-control-prev" : "carousel-control-prev dis_none"}
                                                type="button"
                                                data-bs-target={`#carouselExampleIndicators${index}`}
                                                data-bs-slide="prev"
                                                onClick={() => {
                                                   const carousel = document.getElementById(`carouselExampleIndicators${index}`);
                                                   const items = carousel.querySelectorAll('.carousel-item');
                                                   let activeIndex = Array.from(items).findIndex((item) =>
                                                      item.classList.contains('active')
                                                   );

                                                   // Calculate new index for prev
                                                   const newIndex = (activeIndex - 1 + items.length) % items.length;
                                                   setPlayingVideo({ companyIndex: null, videoIndex: null });
                                                }}
                                             >
                                                <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                                                <span className="visually-hidden">Previous</span>
                                             </button>

                                             <button
                                                className={data.companyVideos.length > 1 ? "carousel-control-next" : "carousel-control-next dis_none"}
                                                type="button"
                                                data-bs-target={`#carouselExampleIndicators${index}`}
                                                data-bs-slide="next"
                                                onClick={() => {
                                                   const carousel = document.getElementById(`carouselExampleIndicators${index}`);
                                                   const items = carousel.querySelectorAll('.carousel-item');
                                                   let activeIndex = Array.from(items).findIndex((item) =>
                                                      item.classList.contains('active')
                                                   );

                                                   // Calculate new index for next
                                                   const newIndex = (activeIndex + 1) % items.length;
                                                   setPlayingVideo({ companyIndex: null, videoIndex: null });
                                                }}
                                             >
                                                <span className="carousel-control-next-icon" aria-hidden="true"></span>
                                                <span className="visually-hidden">Next</span>
                                             </button>

                                          </div>

                                       </div>
                                       <div class="info-vid">
                                          <div class="d-flex align-items-center ">
                                             <h4><a href={"/companyDetails?companyId=" + data.companyId}>{data.name}</a></h4>
                                             {data.jobShadowConcert == 'Y' ? <a href="#" style={{ width: "36px" }} class="tool" data-bs-toggle="tooltip" data-bs-placement="top" data-tip="This company provides job shadow opportunities">
                                                <div class="mx-0"> <img src="images/badge.png" alt="" class="w-100" /></div></a> : ''}
                                          </div>
                                          <span> {data.address1 != '' ? data.address1 : ''}
                                             {data.address1 != '' && data.address2 != '' ? ', ' : ''}
                                             {data.address2 != '' ? data.address2 : ''}<br></br>
                                             {data.city != '' ? data.city : ''}
                                             {data.city != '' && data.state != '' ? ', ' : ''}
                                             {data.state != '' ? data.state : ''}
                                             {data.state != '' && data.zip != '' ? ', ' : ''}
                                             {data.zip != '' ? data.zip : ''}
                                          </span>
                                          <div class="stock-wrap justify-content-between align-items-center mt-2">
                                             <a href={`/jobsByCompany?companyId=` + data.companyId}> Open Jobs</a>
                                          </div>

                                       </div>

                                    </div>
                                 ))}



                              {/* <div class="pagination-wrap text-center mt-3 paginationContent">
                                 <Pagination3
                                    total={totalItems}
                                    itemsPerPage={ITEMS_PER_PAGE}
                                    currentPage={currentPage}
                                    onPageChange={handlePageChange3} />

                              </div> */}

                              {videoList.length === 0 && (
                                 <div className="col-12 text-center ">
                                    <div className="no-videos-message p-4 ">
                                       {/* <h5 className="text-muted mb-2">No videos found</h5> */}
                                       <p className="text-secondary">
                                          We couldn't find any videos matching your selected filters.<br />
                                          {/* Try adjusting your filters or resetting them to explore all available videos. */}
                                       </p>
                                       {/* <button
                                          className="btn btn-secondary text-uppercase  mb-2"
                                          onClick={handleReset}
                                       >
                                          Reset
                                       </button> */}
                                    </div>
                                 </div>
                              )}


                              {showPagination && (
                                 <div className="pagination-wrap text-center mt-3 paginationContent">
                                    <Pagination3
                                       total={totalItems}
                                       itemsPerPage={ITEMS_PER_PAGE}
                                       currentPage={currentPage}
                                       onPageChange={handlePageChange3}
                                    />
                                 </div>
                              )}

                           </div>

                        </div>
                     </div>
                     <div class="col-lg-4 ">
                        <Recent_Jobs />


                     </div>
                  </div>
               </div>
            </section>
            <div className="ofx-hid-mob">
               <Hiring />
            </div>
         </main>



         {showFilterModal && (
            <div className="modal fade show d-block" tabIndex="-1" role="dialog" aria-modal="true">
               <div className="modal-dialog" style={{ margin: "0px" }}>
                  <div className="modal-content" style={{ height: "100vh" }}>
                     <div className="modal-header">
                        <h5 className="modal-title">Filters</h5>
                        <button type="button" className="btn-close" onClick={() => setShowFilterModal(false)}></button>
                     </div>
                     <div className="modal-body">
                        {/* Filter form goes here - basically re-use your filter JSX */}
                        {/* <FilterForm {...propsNeededForForm} /> */}





                        <form onSubmit={handleFilterSubmit} className="vl-horizental-bar align-items-center">
                           {/* Company Name */}
                           <div className="d-grid">
                              <b><label htmlFor="companyName" className="form-label">COMPANY NAME</label></b>
                              <input
                                 ref={companyInputRef}
                                 className="vl-input form-control"
                                 type="text"
                                 value={companyName}
                                 placeholder="Search by Company"
                                 onChange={handleInputChange}
                              />
                           </div>

                           {/* Industry Select */}
                           <div className="d-grid" ref={selectRef}>
                              <b><label htmlFor="industry" className="form-label">INDUSTRY</label></b>
                              <Select
                                 options={industryOptions}
                                 isMulti
                                 closeMenuOnSelect={false}
                                 hideSelectedOptions={false}
                                 components={{ Option: CustomSelectOption, ValueContainer: CustomValueContainer, MultiValue: CustomMultiValue }}
                                 onChange={(selectedOptions) => setSelectedIndustry(selectedOptions ? selectedOptions.map(o => o.value) : [])}
                                 value={industryOptions.filter(i => selectedIndustry.includes(i.value))}
                                 placeholder="Select Industries"

                                 menuIsOpen={menuOpen}
                                 onMenuOpen={() => setMenuOpen(true)}
                                 onMenuClose={() => setMenuOpen(false)}
                                 onFocus={() => setMenuOpen(true)}
                              />
                           </div>

                           {/* County Select */}
                           <div className="d-grid" ref={select2Ref}>
                              <b><label htmlFor="county" className="form-label">LOCATION</label></b>
                              <Select
                                 options={countyOptions}
                                 isMulti
                                 closeMenuOnSelect={false}
                                 hideSelectedOptions={false}
                                 components={{ Option: CustomSelectOption, ValueContainer: CustomValueContainer }}
                                 onChange={(selectedOptions) => setSelectedCounty(selectedOptions ? selectedOptions.map(o => o.value) : [])}
                                 value={countyOptions.filter(c => selectedCounty.includes(c.value))}
                                 placeholder="Select Location"

                                 menuIsOpen={menu2Open}
                                 onMenuOpen={() => setMenu2Open(true)}
                                 onMenuClose={() => setMenu2Open(false)}
                                 onFocus={() => setMenu2Open(true)}
                              />
                           </div>

                           {/* Buttons */}
                           <div className="align-self-end position-relative filterButtonwrap hto-desktop">
                              <a href="#" onClick={handleReset} className="resetall">Reset</a>
                              <button className="filterButton" type="submit">FILTER</button>
                           </div>
                           <div className="align-self-end position-relative filterButtonwrap hto-mobile">
                              <a href="#" onClick={handleReset} className="btn btn-secondary text-uppercase mx-2">Reset</a>
                              <button className="btn btn-primary text-uppercase" type="submit">FILTER</button>
                           </div>
                        </form>




                     </div>
                  </div>
               </div>
            </div>
         )}
      </>
   )
};

VideoLibrary.propTypes = {};

VideoLibrary.defaultProps = {};

export default VideoLibrary;